import Action from 'actions';
import BaseLP from 'services/sports/default/base-lp';
import Const from 'constants';
import {addRoleSuffix, getSimplexUnitName} from 'helpers/simplex-helper';

export default class LP extends BaseLP {
    preparePlayerByLPPlayerId({incomingValues: {id}}) {
        const state = Action.getState();
        const {preparedPlayers} = state.playersData;
        const playersGroupedById = preparedPlayers.groupedBy.playerId();

        let unit = id.replace(Const.LP_UNIT_PREFIX, '').split(Const.LP_ITEM_DELIMITER);

        let player = {...playersGroupedById[unit[0]]};

        if (Const.LP_CAPTAIN_PLAYER_POSITION == unit[1]) {
            player.setAsCaptain();
        }

        player.position = Number(player.position[0]);

        return player;
    }

    prepareMaxSection({incomingValues = {}}) {
        return this.exec('prepareMaxSection_ShowDown', incomingValues);
    }

    prepareSectionByTeam({incomingValues = {}}) {
        return this.exec('prepareSectionByTeam_ShowDown', incomingValues);
    }

    prepareSectionByUniquePosition({incomingValues = {}}) {
        return this.exec('prepareSectionByUniquePosition_ShowDown', incomingValues);
    }

    prepareSectionByCaptainPosition({incomingValues = {}}) {
        return this.exec('prepareSectionByCaptainPosition_ShowDown', incomingValues);
    }

    prepareSectionBySalary({incomingValues = {}}) {
        return this.exec('prepareSectionBySalaryRoles', {
            salaryPropsByRoles: {
                [Const.CAPTAIN_MODE]: 'captain_salary',
                [Const.FLEX_MODE]: 'salary',
            },
        });
    }

    prepareSectionByPlayer({incomingValues = {}}) {
        return this.exec('prepareSectionByPlayer_ShowDown', incomingValues);
    }

    prepareSectionByCreatedLineups({incomingValues = {}}) {
        return this.exec('prepareSectionByCreatedLineups_ShowDown', incomingValues);
    }

    prepareSectionByExposureMax({incomingValues = {}}) {
        return this.exec('prepareSectionByExposureMax_ShowDown', incomingValues, {});
    }

    prepareSectionByExposureMin({incomingValues = {}}) {
        return this.exec('prepareSectionByExposureMin_ShowDown', incomingValues);
    }

    prepareSectionByStacks({incomingValues = {}}) {
        return this.exec('prepareSectionByStacks_ShowDown', incomingValues);
    }

    prepareGeneralSection({incomingValues = {}}) {
        return this.exec('prepareGeneralSection_ShowDown', incomingValues);
    }

    prepareBoundSection({incomingValues = {}}) {
        return this.exec('prepareBoundSection_ShowDown', incomingValues);
    }

    prepareMaxRandomSection({incomingValues = {}}) {
        return this.exec('prepareMaxRandomSection_ShowDown', incomingValues);
    }

    prepareSectionByPosition({incomingValues = {}}) {
        const state = Action.getState();
        const {
            sportConfig,
            playersData: {preparedPlayers},
        } = state;
        const players = preparedPlayers.groupedBy.allowedPositions();
        const positions = sportConfig.getConfigProp('positions', []);

        let result = '';

        Object.keys(positions).map((pos) => {
            let playersOnPos = '',
                posObj = positions[pos];

            players.map((player) => {
                if (!inArray(player.position, posObj.allowedPositions)) {
                    return;
                }

                const lpPlayerId = addRoleSuffix({
                    prefix: player.getId(),
                    role: Const.DEFAULT_MODE,
                });
                playersOnPos += '+' + getSimplexUnitName(lpPlayerId);
            });

            if (!isEmpty(playersOnPos)) {
                result += playersOnPos + '=' + posObj.maxPlayers + '\n';
            }
        });
        // console.log("position\n",result);
        return result;
    }

    subjectToPermanent() {
        const constraints = {
            players: this.exec('prepareSectionByPlayer', {}, ''),
            salary: this.exec('prepareSectionBySalary', {}, ''),
            positions: this.exec('prepareSectionByPosition', {}, ''),
            teams: this.exec('prepareSectionByTeam', {}, ''),
            maxSingleGamePlayersByModes: this.exec(
                'maxSingleGamePlayersByModes',
                {
                    modes: [Const.DEFAULT_MODE, Const.CAPTAIN_MODE],
                },
                '',
            ),
            opposingTeamsInLineup: this.exec(
                'opposingTeamsInLineup',
                {
                    modes: [Const.DEFAULT_MODE, Const.CAPTAIN_MODE],
                },
                '',
            ),
            captainPositions: this.exec('prepareSectionByCaptainPosition', {}, ''),
        };

        return {...constraints};
    }

    subjectToAlterable() {
        const constraints = {
            uniquePositions: this.exec('prepareSectionByUniquePosition', {}, ''),
            createdLineups: this.exec('prepareSectionByCreatedLineups', {}, ''),
            exposureMax: this.exec('prepareSectionByExposureMax', {}, ''),
            exposureMin: this.exec('prepareSectionByExposureMin', {}, ''),
            randomTeamStack: this.exec(
                'stackRandomTeam',
                {
                    modes: [Const.DEFAULT_MODE, Const.CAPTAIN_MODE],
                },
                '',
            ),
            playerCombinationStacking: this.exec(
                'playerCombinationStacking',
                {
                    modes: [Const.DEFAULT_MODE, Const.CAPTAIN_MODE],
                },
                '',
            ),
        };

        return {...constraints};
    }
}
